import React, {PureComponent} from 'react';
import PropTypes from "prop-types";
import {connect} from 'react-redux';
import Head from 'next/head';
import dynamic from 'next/dynamic';

import {loadListings, getStats} from '../../reducers/listings';
import {debounce} from '../../libs/throttle-debounce';

import Container from "@material-ui/core/Container";
import Hidden from "@material-ui/core/Hidden";
import {Dashboard as DashboardLayout} from '../../layouts';
const ListingsTable = dynamic(() => import('./components/Table'));
const ListingsCards = dynamic(() => import('./components/Cards'));
const ListingsFilters = dynamic(() => import('./components/Filters'));
const Snackbar = dynamic(() => import('../../components/Snackbar/Snackbar'));


class Listings extends PureComponent {

    componentDidMount() {
        const {loadListings, getStats, pagination, router} = this.props;
        const {id, ...query} = router.query;
        if (id) {
            loadListings({id, ...pagination, ...query});
            getStats({id});
        }
        else {
            loadListings({...pagination, ...query});
            getStats({});
        }
    }

    render() {
        const {router, loadListings, stats, user} = this.props;
        return (
            <DashboardLayout title="Listings">
                <Container maxWidth="md">
                    <Head>
                        <title>Listings</title>
                    </Head>

                    <Hidden smDown>
                        <ListingsCards stats={stats}/>
                    </Hidden>
                    <ListingsFilters
                        onChange={loadListings}
                        user={user}
                    />
                    <ListingsTable
                        router={router}
                        user={user}
                        fetch={debounce(loadListings, 350)}
                        rowsPerPageOptions={[5, 10, 25, 50, 100]}
                        selectable={true}
                    />
                    <Snackbar/>
                </Container>
            </DashboardLayout>
        )
    }
}

Listings.propTypes = {
    router: PropTypes.object.isRequired,
    loadListings: PropTypes.func.isRequired,
    getStats: PropTypes.func.isRequired,
    listings: PropTypes.array.isRequired,
    stats: PropTypes.object.isRequired,
    pagination: PropTypes.object.isRequired,
    user: PropTypes.object.isRequired,
}

const mapStateToProps = (state) => {
    return {
        listings: state.listings.listings,
        stats: state.listings.stats,
        pagination: state.listings.pagination,
        user: state.auth.user,
    }
}

export {Listings}
export default connect(mapStateToProps, {loadListings, getStats})(Listings)
